import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../../models/configuration.model';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';
import { DataStoreService } from '../../core/services/data-store/data-store.service';

@Injectable()
export class ConfigurationStoreService implements OnDestroy {
  private isAlive = true;
  private configuration = new Subject<Configuration>();

  get configurationStream(): Observable<Configuration> {
    return this.configuration.asObservable();
  }

  constructor(private bafAgent: BafAgentService, private dataStore: DataStoreService) {}

  loadConfiguration() {
    this.bafAgent
      .getConfiguration()
      .takeWhile(() => this.isAlive)
      .subscribe(config => {
        this.dataStore.setErrorId(0);
        this.dataStore.setConfiguration(config);
        this.configuration.next(config);
      });
  }

  ngOnDestroy() {
    this.isAlive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/configuration-store/configuration-store.service.ts